import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkPromotionDetail({news = {}, children}) {
    const slug = news.news_title && news.news_id ? `${changeToSlug(news.news_title)}-d${news.news_id}` : '';

    return <LoadingDetailLink href={slug ? `/${slug}` : ''}>{children}</LoadingDetailLink>;
}
